export const defaultSorted = [{ dataField: "created_at", order: "desc" }];

export const initialFilter = {
  searchKey: "",
  pageNumber: 1,
  pageSize: 20,
};
